/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Verify_Email_Not_Verified_YetInputs */

const en_common_sign_verify_email_not_verified_yet = /** @type {(inputs: Common_Sign_Verify_Email_Not_Verified_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not verified yet. Please click the link in your email first.`)
};

const zh_common_sign_verify_email_not_verified_yet = /** @type {(inputs: Common_Sign_Verify_Email_Not_Verified_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未完成验证，请先前往邮箱点击验证链接。`)
};

/**
* | output |
* | --- |
* | "Not verified yet. Please click the link in your email first." |
*
* @param {Common_Sign_Verify_Email_Not_Verified_YetInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_verify_email_not_verified_yet = /** @type {((inputs?: Common_Sign_Verify_Email_Not_Verified_YetInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Verify_Email_Not_Verified_YetInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_verify_email_not_verified_yet(inputs)
	return zh_common_sign_verify_email_not_verified_yet(inputs)
});
export { common_sign_verify_email_not_verified_yet as "common.sign.verify_email_not_verified_yet" }